export enum GodziPrizeTierType {
  Silver = 0,
  Golden = 1,
  Vip = 2,
}
